import { Button } from "@/components/ui/button";
import { ExternalLink, Sparkles, FileText } from "lucide-react";
import { Link } from "react-router-dom";

export default function ArticlesPanel() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-foreground">Artykuły blogowe</h2>
        <p className="text-muted-foreground text-sm">Zarządzaj treścią bloga i generuj nowe artykuły z AI.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Link to="/ai-generator" target="_blank">
          <div className="bg-card border border-border rounded-xl p-6 hover:border-accent transition-colors h-full">
            <div className="w-12 h-12 rounded-lg bg-accent/15 flex items-center justify-center mb-4">
              <Sparkles className="w-6 h-6 text-accent" />
            </div>
            <h3 className="font-semibold text-foreground mb-2">Generator AI</h3>
            <p className="text-sm text-muted-foreground mb-4">Wygeneruj nowy artykuł blogowy w kilkanaście sekund - SEO-friendly, gotowy do publikacji.</p>
            <Button size="sm" className="gap-2">
              <ExternalLink className="w-3.5 h-3.5" />
              Otwórz generator
            </Button>
          </div>
        </Link>

        <Link to="/blog" target="_blank">
          <div className="bg-card border border-border rounded-xl p-6 hover:border-accent transition-colors h-full">
            <div className="w-12 h-12 rounded-lg bg-primary/15 flex items-center justify-center mb-4">
              <FileText className="w-6 h-6 text-primary" />
            </div>
            <h3 className="font-semibold text-foreground mb-2">Blog publiczny</h3>
            <p className="text-sm text-muted-foreground mb-4">Zobacz wszystkie opublikowane artykuły tak, jak widzą je klienci i Google.</p>
            <Button size="sm" variant="outline" className="gap-2">
              <ExternalLink className="w-3.5 h-3.5" />
              Otwórz blog
            </Button>
          </div>
        </Link>
      </div>

      <div className="bg-accent/5 border border-accent/20 rounded-xl p-5">
        <h3 className="font-semibold text-foreground mb-2">Wskazówka SEO</h3>
        <p className="text-sm text-muted-foreground">
          Publikuj minimum 2-4 artykuły miesięcznie. Skupiaj się na frazach long-tail
          (np. "naklejki 3D na motocykl cena", "doming logo firmowe Warszawa").
          Każdy artykuł = nowa szansa na pojawienie się w Google.
        </p>
      </div>
    </div>
  );
}
